<template>
    <DButton
        :label="__('customers.customers.creditworthiness.terminate_bankruptcy_contracts')"
        mini
        :class="classes"
        @click="openPage()"
    />
</template>

<script setup>
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

const props = defineProps({
    customer: {
        type: Object,
        default: () => {
            return {}
        }
    },
    classes: {
        type: String,
        default: () => {
            return ''
        }
    }
})

function openPage () {
    return router.get(route('customers.customers.terminate_bankruptcy_contracts', { customer: props.customer.id }))
}
</script>
